import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../_services/storage.service';

@Injectable({
	providedIn: 'root'
})
export class JwtInterceptorService implements HttpInterceptor {

	constructor(private storage: StorageService) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		var jwt = this.storage.getItemPlain("access_token");
		if (jwt) {
			request = request.clone({
				setHeaders: {
					Authorization: `Bearer ${jwt}`
				}
			});
		}
		return next.handle(request);
	}
}